import { render, staticRenderFns } from "./-HealthpointLevel.vue?vue&type=template&id=8abb8090&"
import script from "./-HealthpointLevel.vue?vue&type=script&lang=js&"
export * from "./-HealthpointLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports